import { Box, Heading, Text } from "@chakra-ui/react"
import { useState } from "react";
import './Selector_nth.css';


export const Selector_nth = () => {
    const bgg = 'linear-gradient(30deg, rgb(0, 213, 255), rgb(81, 63, 302))'
    const [box, setBox] = useState(9);

    return (
        <Box bg={bgg} p={'10px 0'} className="content">

            <Box className="first_child" w={['90%']} m={'auto'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                <Heading color={"white"} fontSize={'20px'} fontWeight={'medium'}>:first-child</Heading>
                <Box>
                    {Array.from({ length: box }, (_, index) => (
                        <div key={index} className="child">{index+1}</div>
                    ))}
                </Box>
            </Box>

            
            <Box className="last_child" w={['90%']} m={'auto'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                <Heading color={"white"} fontSize={'20px'} fontWeight={'medium'}>:last-child</Heading>
                <Box>
                    {Array.from({ length: box }, (_, index) => (
                        <div key={index} className="child">{index+1}</div>
                    ))}
                </Box>
            </Box>

            <Box className="last_child2" w={['90%']} m={'auto'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                <Heading color={"white"} fontSize={'20px'} fontWeight={'medium'}>:nth-last-child(2)</Heading>
                <Box>
                    {Array.from({ length: box }, (_, index) => (
                        <div key={index} className="child">{index+1}</div>
                    ))}
                </Box>
            </Box>

            
            <Box className="nth_child2" w={['90%']} m={'auto'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                <Heading color={"white"} fontSize={'20px'} fontWeight={'medium'}>:nth_child(2)</Heading>
                <Box>
                    {Array.from({ length: box }, (_, index) => (
                        <div key={index} className="child">{index+1}</div>
                    ))}
                </Box>
            </Box>

            <Box className="nth_child3n" w={['90%']} m={'auto'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                <Heading color={"white"} fontSize={'20px'} fontWeight={'medium'}>:nth_child(3n)</Heading>
                <Box>
                    {Array.from({ length: box }, (_, index) => (
                        <div key={index} className="child">{index+1}</div>
                    ))}
                </Box>
            </Box>

            <Box className="nth_child_odd" w={['90%']} m={'auto'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                <Heading color={"white"} fontSize={'20px'} fontWeight={'medium'}>:nth_child(odd)</Heading>
                <Box>
                    {Array.from({ length: box }, (_, index) => (
                        <div key={index} className="child">{index+1}</div>
                    ))}
                </Box>
            </Box>

            <Box className="nth_child_even" w={['90%']} m={'auto'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                <Heading color={"white"} fontSize={'20px'} fontWeight={'medium'}>:nth_child(even)</Heading>
                <Box>
                    {Array.from({ length: box }, (_, index) => (
                        <div key={index} className="child">{index+1}</div>
                    ))}
                </Box>
            </Box>

            <Box className="nth_child_n4" w={['90%']} m={'auto'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                <Heading color={"white"} fontSize={'20px'} fontWeight={'medium'}>:nth_child(n+4)</Heading>
                <Box>
                    {Array.from({ length: box }, (_, index) => (
                        <div key={index} className="child">{index+1}</div>
                    ))}
                </Box>
            </Box>

            <Box className="nth_child_3n1" w={['90%']} m={'auto'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                <Heading color={"white"} fontSize={'20px'} fontWeight={'medium'}>:nth_child(3n-1)</Heading>
                <Box>
                    {Array.from({ length: box }, (_, index) => (
                        <div key={index} className="child">{index+1}</div>
                    ))}
                </Box>
            </Box>

            <Box className="nth_child_minus_n3" w={['90%']} m={'auto'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                <Heading color={"white"} fontSize={'20px'} fontWeight={'medium'}>:nth_child(-n+3)</Heading>
                <Box>
                    {Array.from({ length: box }, (_, index) => (
                        <div key={index} className="child">{index+1}</div>
                    ))}
                </Box>
            </Box>


        </Box>
    )
}